import type ReloaderService from 'shared/services/reloader.service';
import type LoanService from '../loan.service';
import KpSearchInSearchContext from '../../search/kp-search/KpSearchInSearchContext.svelte';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';

export default class LoansController {

    public kpSearchInSearchContext = KpSearchInSearchContext;

    /*@ngInject*/
    constructor(
        public toProcess: boolean,
        private loanService: LoanService,
        private reloader: ReloaderService,
        private finishedResponseInteractionService: FinishedResponseInteractionService
    ) {
    }

    public async processLoan() {
        await this.loanService.processLoan();
        this.reloader.reloadRoute();
    }

}
